/* eslint-disable @angular-eslint/directive-selector */
import {
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  Optional,
  Renderer2,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  standalone: true,
  selector: `button[mat-button][loading], button[mat-raised-button][loading], button[mat-icon-button][loading],
  button[mat-fab][loading], button[mat-mini-fab][loading], button[mat-stroked-button][loading],
             button[mat-flat-button][loading]`,
})
export class MatButtonLoadingDirective implements OnChanges {
  @Input() loading: boolean;
  @Input() disabled: boolean;
  @Input() color: ThemePalette;
  private spinner?: ComponentRef<MatProgressSpinner>;

  get button() {
    return this.matButton || this.matIconButton;
  }

  constructor(
    @Optional() private matButton: MatButton,
    @Optional() private matIconButton: MatIconButton,
    private viewContainerReference: ViewContainerRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['loading']) {
      return;
    }
    if (changes['loading'].currentValue) {
      this.button._elementRef.nativeElement.classList.add('mat-loading');
      this.button.disabled = true;
      this.createSpinner();
    } else if (!changes['loading'].firstChange) {
      this.button._elementRef.nativeElement.classList.remove('mat-loading');
      this.button.disabled = this.disabled;
      this.destroySpinner();
    }
  }

  private createSpinner(): void {
    if (!this.spinner) {
      this.spinner = this.viewContainerReference.createComponent(MatProgressSpinner);
      this.spinner.instance.color = this.color;
      this.spinner.instance.diameter = 20;
      this.spinner.instance.mode = 'indeterminate';
      this.renderer.appendChild(this.button._elementRef.nativeElement, this.spinner.instance._elementRef.nativeElement);
    }
  }

  private destroySpinner(): void {
    if (this.spinner) {
      this.spinner.destroy();
      this.spinner = undefined;
    }
  }
}
